import logo from './logo.svg';
import './App.css';

function App() {
  const handleClick = () => {
    alert("Welcome to PickaChildcare!");
  };

  return (
    <div className="App">
      <button style={{ padding: '10px 20px', backgroundColor: 'royalblue', color: 'white', border: 'none', borderRadius: '5px' }} 
      onClick={handleClick}>
      Welcome
    </button>  
    </div>
  );
}

export default App;
